import React, { useState } from 'react';
import * as PropTypes from 'prop-types';
import { Bouton } from '@design-system-etat/dsfr-react';
import { useHistory } from 'react-router-dom';
import ModalePerteVol from './ModalePerteVol';
import RoutesSignalerArmePerdueVolee from '../../../../armes/signaler-perte-vol/routes';
import { getPath } from '../../../../../../utils/router';

const BoutonArmePerdueVolee = ({ armesSelectionnees }) => {
    const [displayModalePerteVol, setDisplayModalePerteVol] = useState(false);
    const history = useHistory();
    let display = true;

    if (armesSelectionnees) {
        armesSelectionnees.forEach((element) => {
            if (element.statutId !== 1) {
                display = false;
            }
        });
    }

    const ouvrirModalePerteVol = () => {
        setDisplayModalePerteVol(true);
    };
    const fermerModalePerteVol = () => {
        setDisplayModalePerteVol(false);
    };

    const etape2PerteVol = () => {
        const armesSelectionneesUuid = armesSelectionnees.map((element) => {
            return element.uniquid;
        });

        history.push({
            pathname: getPath(RoutesSignalerArmePerdueVolee),
            state: { listeArme: armesSelectionneesUuid },
        });
    };

    if (!display) {
        return null;
    }

    return (
        <>
            {displayModalePerteVol && (
                <ModalePerteVol
                    fermerModale={fermerModalePerteVol}
                    etape2PerteVol={etape2PerteVol}
                />
            )}
            <Bouton label="Signaler perte/vol" niveau="secondaire" onClick={ouvrirModalePerteVol} />
        </>
    );
};

BoutonArmePerdueVolee.propTypes = {
    armesSelectionnees: PropTypes.array.isRequired,
};

export default BoutonArmePerdueVolee;
